var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6","lg":"4"}},[_c('v-checkbox',{attrs:{"label":"Control Data Permissions for child accounts"},model:{value:(_vm.isAccountManagerLocal),callback:function ($$v) {_vm.isAccountManagerLocal=$$v},expression:"isAccountManagerLocal"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }